<script setup>
import { computed } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: false
  },
  message: {
    type: String,
    required: false,
    default: 'Delete <strong>{name}</strong>?'
  },
  bulkDelete: {
    type: Boolean,
    required: false,
    default: false
  },
  itemsToDelete: {
    type: Array,
    required: false,
    default: () => []
  },
  deleteItem: {
    type: Object,
    required: false,
    default: null
  },
  deleteLoading: {
    type: Boolean,
    required: false,
    default: false
  },
  deleteDialog: {
    type: Boolean,
    required: false,
    default: false
  }
})

const message = computed(() => {
  if (props.bulkDelete) {
    return `Are you sure you want to delete these ${props.itemsToDelete.length} items?`
  }
  let showName = ''
  if (props.name) {
    showName = props.name
  } else {
    showName = props.deleteItem.value?.name
  }
  return props.message.replace(/{name}/g, showName)
})

const emit = defineEmits(['delete', 'toggleDialog'])

const dialog = computed({
  get() {
    return props.deleteDialog
  },
  set(value) {
    emit('toggleDialog')
  }
})
</script>

<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="emit('toggleDialog')">
    <v-card class="pa-3">
      <v-card-title>
        <span>Delete</span>
      </v-card-title>
      <v-card-text class="pt-3 pl-4" v-html="message"></v-card-text>
      <slot name="info"></slot>
      <v-card-actions class="pa-0">
        <v-spacer></v-spacer>
        <v-btn
          @click="emit('toggleDialog')"
          :disabled="deleteLoading"
          variant="text"
          class="text-none"
          color="primary"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="deleteLoading"
          color="red darken-1"
          variant="text"
          class="text-none"
          @click="emit('delete')"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
